module.exports = __webpack_public_path__ + "static/wt-scrollable-sticky-title-968b618d4e4db6849154b4696a7f67cd.png";